import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './user.component';
import { TranslateModule } from '@ngx-translate/core';
import { AddUserByFileComponent } from './add-user-by-file/add-user-by-file.component';
import { CanActivateChildGuard } from 'src/app/core/guards/can-activate-child.guard';

const routes: Routes = [{ path: 'user', component: UserComponent },
{
  path: 'import-user',
  component: AddUserByFileComponent,
  canActivate: [CanActivateChildGuard],

  data: {
    breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_user'],
    defaultPath: 'home-enterprise'
  }
},
{
  path: 'import-user/:id',
  component: AddUserByFileComponent,

  data: {
    breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_user'],
    defaultPath: 'home-enterprise'
  }
},
{
  path: 'import-customer',
  component: AddUserByFileComponent,
  canActivate: [CanActivateChildGuard],


  data: {
    breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_customer'],
    defaultPath: 'home-enterprise'
  }
},
{
  path: 'import-customer/:id',
  component: AddUserByFileComponent,

  data: {
    breadcrumb: ['breadcrumbs.enterprise_manage', 'breadcrumbs.enterprise_customer'],
    defaultPath: 'home-enterprise'
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule]
})
export class UserRoutingModule { }
